import http from './_http'

const group = {
  get: () => http.get(`api/v3/member/group`),
  update: (m) => http.put(`api/v3/member/group`, m),
}
const user = {
  add: (m) => http.post(`api/v3/member/user`, m),
  get: (id) => http.get(`api/v3/member/user/${id}`),
  list: (m) => http.post(`api/v3/member/user/search`, m),
  update: (m) => http.put(`api/v3/member/user`, m),
  delete: (id) => http.delete(`api/v3/member/user/${id}`),
  permission: (id, perm) => http.patch(`api/v3/member/user/${id}/permission`, perm),
  enable: (id) => http.put(`api/v3/member/user/${id}/enable`),
  disable: (id) => http.put(`api/v3/member/user/${id}/disable`),
}
const member  = {
  group, user
}
export default member
export { group, user }